/**
 * functiontoggleRegionSelection() - Přepíná mezi zobrazením mapy a seznamu regionů.
 */
function toggleRegionSelection()
{
	event.preventDefault();

	// Konverze nodeList na Array kvuli podpore IE.
	//		Array.prototype.slice.call více backwards compatible než Array.from
	Array.prototype.slice
		.call( document.querySelectorAll('.mapa, .seznam, .vyber-mapa-abeceda, .vyber-abeceda-mapa') )
		.forEach( function (item) {
			item.classList.toggle('block-visible');
		});
}

window.toggleRegionSelection = toggleRegionSelection;